import { Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { StyledTextField } from "./styles/formFieldStyles";

// Using the StyledTextField component
const FormTextField = ({
  label,
  fieldName,
  emptyOnChange = false,
  helperText = "",
  ...props
}) => {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const hasError = touched[fieldName] && !!errors[fieldName];
  const errorMessage =
    hasError && typeof errors[fieldName] === "string" ? errors[fieldName] : "";
  const labelContent = <Typography variant="caption">{label}</Typography>;

  const handleChange = (event) => {
    if (emptyOnChange) {
      return;
    }

    setFieldValue(fieldName, event.target.value);
  };

  return (
    <StyledTextField
      label={labelContent}
      margin="dense"
      fullWidth
      value={values[fieldName]}
      onChange={handleChange}
      error={hasError}
      helperText={hasError ? errorMessage : helperText}
      onBlur={handleBlur}
      {...props}
    />
  );
};

export default FormTextField;
